import {
  GuideMaterialApiRequest,
  UpdateGuideMaterialRequest,
} from '@/data/payload/api/GuideMaterialRequest'
import {
  PostGuideMaterialInterface,
  DeleteGuideMaterialInterface,
  UpdateGuideMaterialInterface,
} from '@/data/payload/contracts/GuideMaterialRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { GuideMaterialDataMapper } from '@/data/persistences/mappers/GuideMaterialDataMapper'
import { GuideMaterialRepositoryInterface } from '@/data/persistences/repositories/contracts/GuideMaterialRepositoryInterface'
import { GuideMaterial } from '@/domain/entities/QuickGuideMaterial'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class GuideMaterialApiRepository
  implements GuideMaterialRepositoryInterface {
  private service: ApiService
  private mapper: GuideMaterialDataMapper

  constructor(service: ApiService, mapper: GuideMaterialDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(
    payload: DeleteGuideMaterialInterface
  ): Promise<GuideMaterial> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.GUIDE_MATERIAL_DELETE,
      undefined,
      payload as GuideMaterialApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(
    payload: PostGuideMaterialInterface
  ): Promise<GuideMaterial> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.GUIDE_MATERIAL,
      undefined,
      payload as GuideMaterialApiRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateGuideMaterialInterface,
    id: number
  ): Promise<GuideMaterial> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.GUIDE_MATERIAL}/${id}`,
      undefined,
      payload as UpdateGuideMaterialRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<GuideMaterial> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.GUIDE_MATERIAL,
      params
    )
    return this.mapper.convertFromApi(resp)
  }
}
